import { useState } from 'react'

import { toast } from 'react-toastify'
import { Form, Modal } from 'react-bootstrap'
import { CheckCircleFill, XCircleFill } from 'react-bootstrap-icons'

import { CustomButton } from '../../../components/CustomButton'

import apinode from '../../../services/apinode'

import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'

export function ModalCriarInventario({ isOpen, onClose, loadInventories }) {
  const [inventoryName, setInventoryName] = useState('')
  const [isRequestAddInventoryLoading, setIsRequestAddInventoryLoading] =
    useState(false)

  async function handleAddInventory() {
    if (inventoryName.trim() === '') {
      return toast.error('Por favor, insira um nome para o inventário.')
    }

    try {
      setIsRequestAddInventoryLoading(true)

      await apinode.post(
        `inventario/inserirAtualizarParamInventario/${localStorage.idconta}`,
        {
          DESCRICAO: inventoryName,
        },
      )

      setInventoryName('')
      loadInventories()
      toast.success('Inventário adicionado com sucesso!')
    } catch (error) {
      sendErrorApiMessage(error, 'Erro ao criar o inventário!')
    } finally {
      onClose()
      setIsRequestAddInventoryLoading(false)
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
    >
      <Modal.Header>
        <Modal.Title>Novo Inventário</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Control
          placeholder="Nome do Inventário..."
          value={inventoryName}
          onChange={(e) => setInventoryName(e.target.value)}
        />
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          color="#ff0000"
          title="Fechar"
          onClick={onClose}
        >
          <XCircleFill />
        </CustomButton>

        <CustomButton
          color="#198754"
          title="Adicionar"
          onClick={handleAddInventory}
          isLoading={isRequestAddInventoryLoading}
          isLoadingText={'Adicionando...'}
        >
          <CheckCircleFill />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
